<template>
  <div class="main-container">
    <h1 class="page-title">Database operation</h1>

    <div class="commands">
      <v-btn @click="seedUsers">Seed users</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    seedUsers() {
      // this.$store.dispatch('seedUsers')
    },
  },
};
</script>
